import { DSAttendanceStatus } from '@/constants/ds-attendance.constants'
import type { DSAttendanceContainerDetailResponse } from '@/Network/Types/Responses/DsAttendancePolicyResponses'

/**
 * rejected-sheet-resubmission (Q9–Q11, CA1–CA3): o que a tela do registro oferece
 * para uma folha reprovada. Espelha a regra do backend (`assertNewSheetAllowed` +
 * substituto ativo), que continua sendo a trava real.
 */
export type NewSheetAction = 'SUBMIT' | 'GO_TO_REPLACEMENT' | 'NONE'

/** Canais que criam um registro novo a cada envio: não há "nova folha no mesmo registro". */
const OTHER_CHANNELS = new Set(['EXTERNAL_APP', 'NON_DAILY_SHEET'])

type NewSheetDetails = Pick<
  DSAttendanceContainerDetailResponse,
  'status' | 'monitoringType' | 'replacementContainerId'
> & { kind?: string | null }

/**
 * `canSend` = pode enviar registro (`attendance_emitting`): quem reenvia a folha corrigida é
 * o time de Escalas (#3072). No SpiceDB o receptor também é emissor, então a Auditoria segue
 * vendo a ação.
 */
export function newSheetActionFor(
  details: NewSheetDetails | null,
  canSend: boolean
): NewSheetAction {
  if (!details || !canSend) return 'NONE'
  if (details.status !== DSAttendanceStatus.REJECTED) return 'NONE'
  if (details.kind === 'ATIVIDADE' || OTHER_CHANNELS.has(details.monitoringType ?? '')) {
    return 'NONE'
  }
  return details.replacementContainerId ? 'GO_TO_REPLACEMENT' : 'SUBMIT'
}
